import { Injectable } from '@angular/core';
import { ActiveLabPanelDto } from '../models/active-panel-dto';
import { RequisitionDto } from '../models/requisition-dto';
import { RequisitionStatusHistoryDto } from '../models/requisition-status-history-dto';
import { PackageCheckComponent } from '../modules/receiving-list/package.check';

@Injectable({
  providedIn: 'root'
})
export class LocalRequistionService {
  requisition: RequisitionDto;
  requisitionHistory: RequisitionStatusHistoryDto[];
  activeLabPanel: ActiveLabPanelDto;
  labPanels: ActiveLabPanelDto[] = [];

  constructor() { }

  public setRequisition(req: RequisitionDto) {
    this.requisition = req;
  }
  public getRequisition() {
    return this.requisition;
  }
  public setRequisitionStatusHistoryList(reqHistory: RequisitionStatusHistoryDto[]) {
    this.requisitionHistory = reqHistory;
  }
  public getRequisitionStatusHistoryList() {
    return this.requisitionHistory;
  }
  public setLabPanelTestType(testtype) {
    this.activeLabPanel = testtype;
  }
  public getLabPanelTestType() {
    return this.activeLabPanel;
  }
  public setActiveLabPanels(labPanels) {
    this.labPanels = labPanels;
  }
  public getLabPanels() {
    return this.labPanels;
  }
}